export default __webpack_public_path__ + "static/media/asesorapresik.47365cc7.webp";